import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import Fab from '@material-ui/core/Fab';

import { saveSession } from '../../../store/actions/session.actions';

const styles = theme => ({
  saveBtn: {
    zIndex: '10',
    color: 'white',
    position: 'fixed',
    bottom: theme.spacing.unit * 4,
    right: theme.spacing.unit * 4,

    '&:disabled': {
      color: 'white',
      backgroundColor: theme.palette.green,
    },
  },
});

class SaveSessionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.saveSessionData = this.saveSessionData.bind(this);
  }

  saveSessionData() {
    this.props.saveSession();
  }

  render() {
    const { classes, isSaved } = this.props;

    return (
      <Fab
        onClick={this.saveSessionData}
        color="secondary"
        className={classes.saveBtn}
        disabled={isSaved}
      >
        <Icon>{isSaved ? 'check' : 'save'}</Icon>
      </Fab>
    );
  }
}

SaveSessionContainer.propTypes = {
  saveSession: PropTypes.func.isRequired,
  isSaved: PropTypes.bool.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(connect(null, { saveSession })(SaveSessionContainer));
